// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';

// img
import singleDownloadImg from '../img/download_img.png';

function Gaap03AllPath(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title"><em>De novo</em> assembly </h2>
            <h2 className="content_title2">Genome assembly</h2>
            <div className="content_command_title">ALLPATHS-LG</div><br/>
            <div className="content_text">
                ALLPATHS‐LG is able to perform de novo assembly of large mammalian genomes. 
                It has been designed to use reads generated on the Illumina platform, 
                and optimized for reads of approximately 100-bp. However, ALLPATHS‐LG 
                (referred to here as ALLPATHS) requires a minimum of 2 paired‐end libraries 
                – one fragment library with overlapping paired-end reads and one jumping 
                library with long insert size.
            </div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://software.broadinstitute.org/allpaths-lg/blog/?page_id=12" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">Preparing ALLPATHS input files</li>
            <div className="content_text">
                Before running the ALLPATHS command, it is first necessary to gather 
                the read data in the appropriate formats, and then add metadata to 
                describe them. The Perl script PrepareAllPathsInputs.pl can be used 
                to automatically convert a set of BAM, fasta, fastq, or fastb files 
                to ALLPATHS input files.
            </div>
            <CommandBox lines={[
                {data:'PrepareAllPathsInputs.pl DATA_DIR=/data PLOIDY=1 IN_GROUPS_CSV=in_groups.csv IN_LIBS_CSV=in_libs.csv'},
            ]}
            /><br/>
            <li className="content_description">Options for PrepareAllPathsInputs.pl</li>
            <OptionTable
                data={[
                    {   option:'DATA_DIR',
                        desc:'specify the location of the ALLPATHS DATA directory where the converted reads will be placed'},
                    {   option:'PLOIDY',
                        desc:'specify whether to generate the ploidy file'},
                    {   option:'IN_GROUPS_CSV',
                        desc:'specify the file that stores the locations of the files to be converted'},
                    {   option:'IN_LIBS_CSV',
                        desc:'specify the file that stores the library information of the files to be converted'},    
                ]}
            /><br />
            <li className="content_description">ALLPATHS-LG Command</li>
            <CommandBox lines={[
                {data:'RunAllPathsLG PRE=<pre> REFERENCE_NAME=test.genome DATA_SUBDIR=data RUN=run SUBDIR=test'},
            ]}
            /><br/>
            <li className="content_description">Optrions for RunAllPathsLG</li>
            <OptionTable
                data={[
                    {   option:'PRE',
                        desc:'specify the location of the root directory in which ALLPATHS pipeline directory will be created'},
                    {   option:'REFERENCE_NAME',
                        desc:'specify the REFERENCE (organism) directory name, which should be set to the same  value of organism_name as given in in_libs.csv'},
                    {   option:'DATA_SUBDIR',
                        desc:'specify the location of the DATA directory, which contains all the converted read data'},
                    {   option:'RUN',
                        desc:'specify the directory, which contains all the intermediate files'},    
                    {   option:'SUBDIR',
                        desc:'specify the directory, where the final assembly is generated, along with some evaluation files'},   
                ]}
            /><br />
            <li className="content_description">Output of ALLPATHS</li>
            <div className="content_text">
                The results of the assembly are given in the following two files, final.assembly.
                fasta and final.assembly.efasta. Both these files contain the final flattened and scaffolded assembly. 
                The efasta, “enhanced” fasta, file is a  new format used by ALLPATHS and is based on the standard fasta file format.
            </div>
            <div className="content_buttons_div">
                <Link to="/Gaap03"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap03_Abyss"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap03AllPath;